export const isDevelopment = () => process.env.NODE_ENV === 'development'
export const isDemo = () => process.env.NODE_ENV === 'demo'
export const isProduction = () => process.env.NODE_ENV === 'release'
export const arePositionQuotesEnabled = () =>
  process.env.VUE_APP_DISABLE_POSITION_QUOTES !== 'true'
